<template>
  <div>
    <b-modal
      id="modal-prevent-closing"
      :titleHtml="$t('label.gdpr-title')"
      size="xl"
      @hidden="resetModal"
      v-model="showPopup"
      centered
      :header-bg-variant="headerVariant"
      header-text-variant="light"
      body-bg-variant="light"
      body-text-variant="dark"
      footer-bg-variant="warning"
      footer-text-variant="dark"
    >
      <b-container fluid>
        <b-row class="mb-1 text-left">
          <b-col v-html="$t('label.gdpr-message')"> </b-col>
        </b-row>
      </b-container>
      <template v-slot:modal-footer>
        <div class="w-100">
          <!-- <p class="float-left"></p> -->
          <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group :state="nameState" label-for="name-input">
              <b-form-checkbox
                id="name-input"
                v-model="status"
                :state="nameState"
                name="checkbox-1"
                value="accepted"
                required
                v-html="$t('label.gdpr-acceptance-message')"
              ></b-form-checkbox>
              <b-button
                variant="primary"
                size="sm"
                class="ml-1 float-right"
                @click="handleOk"
                >{{ $t("button.ok") }}</b-button
              >
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="resetModal"
                >{{ $t("button.close") }}</b-button
              >
            </b-form-group>
          </form>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
//---- components ---------
//---- mixins -------------
//---- services -----------
import { appLocalStorage } from "@/app/services/app-storage.js";
import projectHomeService from "@/app/services/projectHome.service";
//---- 3rd-parties --------

export default {
  data() {
    return {
      status: "",
      nameState: null,
      showGDPR: false,
    };
  }, // end data

  created() {
    let isAccepted = appLocalStorage.getItem(this.username + ".gdpr") === "accepted";
    if (isAccepted)
      return;

    // check the GDPR configuration
    projectHomeService.showGDPR()
      .then((res) => {
        let resFromServer = res.data?.isSubjectToGDPR;
        if (resFromServer === "geolocalization") {
          this.$store.dispatch("advisorCustom/getGeoLocalizationInformation");
        } else {
          this.showGDPR = resFromServer === "true";
        }
      })
      .catch(() => {
        // do nothing
      });
  }, // end created

  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    }, // end checkFormValidity()

    resetModal() {
      if (this.status !== "accepted") {
        this.nameState = null;
        this.logout();
      }
    }, // end resetModal()

    handleOk(bvModalEvt) {
      this.status = "accepted";
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
      appLocalStorage.setItem(this.username + ".gdpr", "accepted");
    }, // end handleOk()

    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    }, // end handleSubmit()

    logout() {
      // window.localStorage.clear();
      window.sessionStorage.clear();
      this.$store.dispatch("onLogout");
      this.$store.dispatch("auth/logout").then(() => this.safeRouterPush("/login"));
    }, // end logout()
  },
  computed: {
    username() {
      return this.$store.getters["auth/username"]
    },
    showPopup() {
      return this.$store.getters["advisorCustom/isSubjectToGDPR"] || this.showGDPR;
    }, // end showPopup()
  }, // end computed
};
</script>